/** Collect text that may contain LaTeX from a quiz question for MathJax gating. */
export const collectQuizItemMathText = (item: {
    title?: string | null;
    textOptions?: Array<{ text?: string | null } | null> | null;
    questionContentSnapshot?: string | null;
    content?: string | null;
}): string => {
    const parts: string[] = [item.title ?? '', item.questionContentSnapshot ?? '', item.content ?? ''];
    (item.textOptions ?? []).forEach((opt) => {
        if (opt?.text) parts.push(opt.text);
    });
    return parts.join('\n');
};

/** Cheap non-crypto hash for remount keys when preview content edits without id change. */
export const hashMathText = (text: string): string => {
    let hash = 0;
    for (let i = 0; i < text.length; i += 1) {
        hash = (hash * 31 + text.charCodeAt(i)) | 0;
    }
    return String(hash);
};
